module.exports = __webpack_public_path__ + "img/yundo.eb328e2d.png";